import { reactive, UnwrapRef } from 'vue'
import { ElNotification } from 'element-plus'
import { AxiosError } from 'axios'
import store from '@/store'
import { iFormErrors } from '@/types/common/responses'

export type iFormRequest<T> = {
  pending: boolean
  error: boolean
  success: boolean

  errorMessage: string
  errors: iFormErrors<T>
}

const useFormRequest = <T>() => {
  type iFailOptions = {
    errors?: iFormErrors<T>
    message?: string
    showMessage: boolean
  }

  const state = reactive<iFormRequest<T>>({
    pending: false,
    error: false,
    success: false,

    errorMessage: '',
    errors: {} as iFormErrors<T>
  })

  return {
    state,

    start () {
      state.pending = true
      state.success = false
      state.errorMessage = ''
      state.error = false
      state.errors = {} as UnwrapRef<iFormErrors<T>>
    },
    end () {
      state.pending = false
    },
    success () {
      state.pending = false
      state.success = true
    },
    reset () {
      state.pending = false
      state.success = false
      state.errorMessage = ''
      state.error = false
      state.errors = {} as UnwrapRef<iFormErrors<T>>
    },
    fail (options: iFailOptions = {} as iFailOptions) {
      state.pending = false
      state.error = true
      state.errorMessage = options.message || ''
      state.errors = (options.errors || {}) as UnwrapRef<iFormErrors<T>>

      if (options.showMessage && options.message) {
        ElNotification({
          title: 'Ошибка',
          message: options.message,
          type: 'error'
        })
      }
    },
    async tryRequest (callback: () => void): Promise<void> {
      try {
        this.start()
        await callback()
        this.success()
      } catch (e: unknown) {
        /*
         * @todo: весь этот блок по идее надо куда то на более низкий уровень переставить
         *   оставив здесь только смену состояний, чтобы обработка была не только у форм
         */
        if (e instanceof AxiosError && e.response) {
          if (e.response.status >= 500) {
            this.fail({ message: 'Серверная ошибка', showMessage: true })
          } else {
            switch (e.response.status) {
              case 401:
                store.logout()
                this.end()
                break
              case 403:
                this.fail({ message: 'Действие запрещено', showMessage: true })
                break
              case 404:
                this.fail({ message: 'Объект не найден', showMessage: true })
                break
              case 422:
                this.fail({ errors: e.response.data.errors, showMessage: false })
                break
              case 409:
                this.fail({ message: e.response.data.error, showMessage: true })
                break
              default:
                this.fail({ message: 'Неправильные данные', showMessage: true })
            }
          }
        } else {
          throw e
        }
      }
    }
  }
}

export default useFormRequest
